import { ReactNode } from 'react';

import { ExternalToast, toast } from 'sonner';

export const toastSuccess = (msg: ReactNode, options?: ExternalToast) => {
  toast.success(msg, {
    style: {
      fontSize: '18px',
    },
    ...options,
  });
};

export const toastError = (msg: ReactNode, options?: ExternalToast) => {
  toast.error(msg, {
    style: {
      fontSize: '18px',
    },
    ...options,
  });
};
